"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = exports.set = exports.get = void 0;
var SESSION_URL_KEY = 'auth_redirect_url';
var get = function get() {
  var url = sessionStorage.getItem(SESSION_URL_KEY);
  if (!url) return null;
  return decodeURIComponent(url);
};
exports.get = get;
var set = function set(redirectUrl) {
  sessionStorage.setItem(SESSION_URL_KEY, encodeURIComponent(redirectUrl));
};
exports.set = set;
var remove = function remove() {
  sessionStorage.removeItem(SESSION_URL_KEY);
};
exports.remove = remove;
//# sourceMappingURL=storage.js.map